/*global page */
var FakeCation = window.FakeCation || {};

(function (fc) {
  "use strict";

  var pageManager = {
    pages: {},
    urlIndex: {}
  };

  pageManager.add = function (page) {
    var name = page.name,
      url = page.url;
    pageManager.pages[name] = page;
    pageManager.urlIndex[url] = page;

  };

  pageManager.getByName = function (name) {
    return pageManager.pages[name];
  };

  pageManager.getByUrl = function (url) {
    return pageManager.urlIndex[url];
  };

  pageManager.Page = function (name, url, section) {
    this.name = name;
    this.url = url;
    this.section = section;
    this.sectionElement = null;
    this.bound = false;
  };

  pageManager.Page.prototype = {
    $:function(selector) {
      return this.sectionElement.querySelectorAll(selector);
    },
    $$:function(selector) {
      return this.sectionElement.querySelector(selector);
    },
    fallbackFromMatches: function (target, selector) {
        var nodes = (target.parentNode || target.document).querySelectorAll(selector);
                    
        function compareToTargetNode(node){
                return node === target;
        }
                     
        nodes = Array.prototype.slice.call(nodes);
        
        if (nodes.filter(compareToTargetNode).length >= 1) {
            return true;                          
        }
    },
    render: function () {
      if (!this.sectionElement) {
        this.sectionElement = document.querySelector(this.section);
      }
      if (this.html) {
        this.sectionElement.innerHTML = this.html;
      }
    },
    run: function (ctx, next) {
      console.log(this.name, this.url, ctx);
    },
    bind: function (ctx, next) {
      if (!this.bound) {
        if (this.eventHandlers && this.sectionElement) {
          this.eventHandlers.forEach(function (eventHandler) {
            this.sectionElement.addEventListener(eventHandler.event, function (targetSelector, handler, e) { 
                if (typeof e.target.matches === 'function') {
                    if (e.target.matches(targetSelector)) {
                        handler.call(this, e);
                    }
                } else {
                   if(this.fallbackFromMatches(e.target, targetSelector)) {
                        handler.call(this, e);
                   }
                }
             
            }.bind(this, eventHandler.target, eventHandler.handler));
           
          }.bind(this));
        }
        this.bound = true;
      }  else {
        console.log(this.name + ' already bound');
     }
    },
    destroy: function () {

    }
  };

  pageManager.Page.create = function (name, url, section) {
    var page = new pageManager.Page(name, url, section);
    page.super = {};
    page.super.render = pageManager.Page.prototype.render.bind(page);
    page.super.run = pageManager.Page.prototype.run.bind(page);
    page.super.destroy = pageManager.Page.prototype.destroy.bind(page);
    return page;
  };

  fc.pageManager = pageManager;

}(FakeCation));
